module.exports = __webpack_public_path__ + "assets/img/8_1754.63dea695.jpg";